<template>
  <div id="app">
    <MainSite/>
  </div>
</template>

<script>

import MainSite from "@/components/MainSite";
export default {
  name: 'App',
  components: {
    MainSite
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
